export default __webpack_public_path__ + "static/15-60e97a5510d88a02b247533b514342b7.jpg";